import { Component } from "@angular/core";

@Component({
  selector: "text-editor-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "Tamil Text Editor";

}
